import React, { useMemo } from 'react'
import { Separator } from '../separator'
import { useAppSelector } from '../../redux/hook';

export interface MobileTableItemInterface{
  header:string,
  contents:string[],
  placeholder: string,
}


export interface MobileTableMobileProps{
  title:string,
  items:MobileTableItemInterface[],
  variant?: "default" | "full",
}


function MobileTableMobile({variant="default", ...props}:MobileTableMobileProps) {
  const applicationStep2FormData = useAppSelector(state => state.app.ApplicationStep2Slice.formData);

  const selectedLoan = useMemo(() => {
    if(props.title.includes("Current")){
      return applicationStep2FormData.current_loan_type;
    }else{
      return applicationStep2FormData.new_loan_type;
    }
  }, [applicationStep2FormData, props.title])
  return (
    <div className='ohc-household-structure-mobile-table'>
      {props.title && <>
        <div className='ohc-household-structure-mobile-table-header'>
          <div className='ohc-household-structure-mobile-table-column-1-header'><p>{props.title}</p></div>
        </div>
        <Separator style={{ margin: "8px 0"}} variant="solid"/>
      </>}
      
      {props.items.length > 0 && props.items.map((row_item,_index)=>{
        const key = `${row_item.header}_${_index}`;
        const filteredContents = row_item.contents.filter(item => item !== "");
        
        return(
          <div key={key}>
            <div  className='ohc-household-structure-mobile-table-content'>
              <div className={`ohc-household-structure-mobile-table-column-1 ohc-household-structure-mobile-table-header ${variant === "full" ? "ohc-household-structure-mobile-table-header-full" : ""}`}>
                <p>{row_item.header}</p>
              </div>
      
              <div className='ohc-household-structure-mobile-table-column-2'>
                {row_item.contents.length > 0 && row_item.contents.map((item,_index)=>{
                  const key = `${item}_${_index}`;
                  return <p key={key}>{item}</p>
                })}
                {
                  row_item.header === "Loan"
                  ? !selectedLoan && <p className='ohc-household-structure-table-placeholder'>{row_item.placeholder}</p>
                  : filteredContents.length === 0 && <p className='ohc-household-structure-table-placeholder'>{row_item.placeholder}</p>
                }

              </div>
            </div>
            {props.items.length - 1 !== _index && <Separator style={{ margin: "16px 0"}}/>}
          </div>
        )
      })}

      
    </div>
  )
}

export default MobileTableMobile